import React from "react";
import { connect } from "react-redux";
import SinglePreviewCard from "./SinglePreviewCard";
import { COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY } from "config/CustomEnums";

const CouponCampaignEaringRuleCard = (campaignData) => {
  return [
    {
      step: 2,
      anchorKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.requirementsSection.sectionKey,
      sectionTitle: "REQUIREMENTS",
      sectionContent: [
        {
          haveTranslation: false,
          title: "Required points",
          field: 'requiredPoints',
          isMandatory: true,
          anchorKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.requirementsSection.sectionContent.required_points_key,
        },
      ]
    },
    ...campaignData?.showCouponLimit ? [
      {
        step: 2,
        anchorKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionKey,
        sectionTitle: "LIMITS",
        sectionContent: [
          {
            haveTranslation: false,
            title: "Display the overall limit in the campaign",
            field: 'displayOverLimit',
            isMandatory: true,
            isBoolean: true,
            anchorKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.display_overall_limit_key,
          },
          {
            haveTranslation: false,
            title: "Per head coupon acquiring limit during the campaign active period",
            field: 'perHeadLimit',
            anchorKey: COUPON_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.limitSection.sectionContent.per_head_limit_key,
          },
        ]
      },
    ] : [],
  ]
}

const CouponCampaignEaringRulePreviewCard = ({
  language,
  errors,
  campaignData,
  hideEditButton = false,
}) => {
  return (
    <SinglePreviewCard
      language={language}
      data={campaignData}
      cardInfo={CouponCampaignEaringRuleCard(campaignData)}
      errors={errors}
      hideEditButton={hideEditButton}
    />
  )
}

const mapPropsToState = (state) => ({
  errors: state.createCampaign.errorFields,
});

export default connect(mapPropsToState)(CouponCampaignEaringRulePreviewCard);